import React from 'react'
import { AdsProvider } from './AdsProvider'
import { IsMobileProvider } from './IsMobileProvider'
import { UserProvider } from './UserProvider'
import { ConfigProvider } from './ConfigProvider'
import { ConsentProvider } from './ConsentProvider'
import { DarkProvider } from './DarkProvider'

export const SharedContextProvider = ({ children }) => {
    return (
        <ConfigProvider>
            <AdsProvider>
                <IsMobileProvider>
                    <UserProvider>
                        <DarkProvider>
                            <ConsentProvider>{children}</ConsentProvider>
                        </DarkProvider>
                    </UserProvider>
                </IsMobileProvider>
            </AdsProvider>
        </ConfigProvider>
    )
}
